<template>
  <span>
    <widget-common-props :field="field" @changeProp="changeProp" />

    <b-form-group label="Placeholder" label-cols="3">
      <b-form-input
        @change="changeProp"
        label="Placeholder"
        v-model="field.params.placeholder"
      />
    </b-form-group>
    <b-form-group label="Tooltip" label-cols="3">
      <b-form-input
        @change="changeProp"
        label="Tooltip"
        v-model="field.params.tooltip"
      />
    </b-form-group>

    <b-form-group label="" label-cols="3">
      <b-form-checkbox @input="changeProp" v-model="field.params.show"
        >Show Value</b-form-checkbox
      >
    </b-form-group>

    <b-form-group label="Expression" label-cols="3">
      <b-form-input @change="changeProp" v-model="field.params.expression" />
    </b-form-group>
  </span>
</template>

<script>
import WidgetCommonProps from "../WidgetCommonProps.vue";
import WidgetPropMixin from "../WidgetPropMixin.js";

export default {
  name: "FormulaProps",
  components: { WidgetCommonProps },
  mixins: [WidgetPropMixin],
  computed: {},
};
</script>
